<template>
    <div>
        <div ref="editor" class="" :style="{ width: width+'px'}"></div>
        <Upload v-if="isupload" :config="{total:1}" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
    </div>
</template>

<script>
    import E from 'wangeditor'
    import Upload from '@/components/file/Upload';

    export default{
        name: 'editor',
        components: {
            // Editor,
            // Toolbar,
            Upload
        },
        props:{
            text: {
                type: String,
                default: ''
            },
            width: {
                type: Number,
                default: 460
            },
            height: {
                type: Number,
                default: 750
            }
        },
        data() {
            return {
                isupload: false,
                editor: null,
            }
        },
        watch: {
            text: function (n, o) {
                if (n !== this.editor.txt.html()) {
                    this.editor.txt.html(this.text)
                }
            }
        },
        methods: {
            seteditor() {
                let self = this;
                this.editor = new E(this.$refs.editor)
                // 配置全屏功能按钮是否展示
                this.editor.config.showFullScreen = true
                this.editor.config.zIndex = 999
                this.editor.config.height = this.height
                this.editor.config.width = this.width
                this.editor.config.uploadImgFromMedia = function () {
                    self.isupload = true
                    // 1.调用自己的媒体库并显示UI页面方法
                    // ...
                    // 2.将媒体库返回的图片地址插入到编辑器中,假设imgUrl为媒体返回的图片地址变量
                    //editor.cmd.do( 'insertHTML', `<img src="${imgUrl}" style="max-width:100%;"/>` )
                }
                this.editor.config.customInsertVideo = function (videoUrl) {
                    // videoUrl 是返回的视频地址
                    // 初始化视频
                    // new Player({
                    //     id: 'mse',
                    //     url: videoUrl
                    // });
                }
                // 配置 onchange 回调函数
                this.editor.config.onchange = function (newHtml) {
                    self.$emit('get-content', newHtml)
                };
                // 配置触发 onchange 的时间频率，默认为 200ms
                this.editor.config.onchangeTimeout = 500; // 修改为 500ms
                this.editor.create()
                this.editor.txt.html(this.text)
            },
            /*获取图片*/
            returnImgsFunc(e) {
                if (e != null) {
                    let file_length = e.length
                    for (let i=0; i < file_length; i++) {
                        if (e[i].file_type === 'image') {
                            this.editor.cmd.do('insertHTML', `<img src="${e[i].file_path}" alt="" style="max-width:100%;" />`)
                        }else if (e[i].file_type === 'video') {
                            this.editor.cmd.do(
                                'insertHTML',
                                `<video width="50%" height="50%" controls>
                <source file-id="${e[i]['file_id']}" src="${e[i]['file_path']}" type="video/mp4">
                <object file-id="${e[i]['file_id']}" data="${e[i]['file_path']}" width="50%" height="50%">
                  <embed file-id="${e[i]['file_id']}" src="${e[i]['file_path']}" width="50%" height="50%">
                </object>
              </video>`
                            )
                        }else {
                            this.editor.cmd.do(
                                'insertHTML',
                                `<a file-id="${e[i]['file_id']}" href="${e[i]['file_path']}" download="${e[i]['file_path']}" target="_blank">${e[i]['real_name']}</el-link>`
                            )
                        }
                    }
                }
                this.isupload = false;
            },
            // 编辑器销毁
            editorDestroy() {
                if (this.editor) {
                    this.editor.destroy()
                    this.editor = null
                }
            },
        },
        destroyed() {
            this.editorDestroy()
        },
        mounted() {
            this.seteditor()
        },
    }
</script>
<style scoped>
    /*.editor{*/
    /*    border: 1px solid #bcc7d3;*/
    /*}*/
    /*.toolbar{*/
    /*    border-bottom: 1px solid #bcc7d3;*/
    /*}*/
</style>




// WEBPACK FOOTER //
// src/components/tsk/editor.vue